<main-header></main-header>
<main>
    <div class="container">
        <div class="top-part">
            <div class="breadcrumb">
                <div class="wrap-text">
                    <b>
                        My projects and data connections
                    </b>
                </div>
            </div>
        </div>
    </div>
    <div class="middle-part middle-part_with-sidebar projects">
        <div class="sidebar">
            <div class="block block-navigation"></div>
        </div>
        <div class="main">
            <div class="tabs">
                <div class="tab active">
                    <div class="tab-wrap">
                        <a>
                            My projects
                        </a>
                    </div>
                </div>
            </div>
            <div [ngClass]="{'loading': !dataLoaded, 'projects-container':true, 'container':true}">
                <a routerLink="/upload" class="create-link">Create new project</a>

                <table class="table-border-bottom">
                    <thead>
                    <tr>
                        <th>
                            Projects
                        </th>
                        <th>
                            Last modified
                        </th>
                        <th>
                            File
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let proj of projects">
                        <td class="project">
                            <div class="flex-column">
                                <b>
                                    <a [routerLink]="proj.url" [queryParams]="{projectId: proj.id}">
                                        {{proj.name}}
                                    </a>
                                </b>
                                <div class="flex-column">
                                    <div *ngIf="!proj.editMode" class="flex-row">
                                        <a (click)="proj.editMode = true">rename</a>
                                        <a mwlConfirmationPopover
                                           popoverTitle="Confirm delete"
                                           popoverMessage="Are you sure?"
                                           cancelText="No"
                                           confirmText="Yes"
                                           placement="top"
                                           (confirm)="deleteProject(proj)">delete</a>
                                        <a (click)="duplicateProject(proj)">duplicate</a>
                                        <a target="_blank" [href]="proj.downloadUrl">export</a>
                                    </div>
                                    <div *ngIf="proj.editMode" class="flex-row rename">
                                        <input [(ngModel)]="proj.name" [ngModelOptions]="{standalone: true}" type="text" />
                                        <button (click)="renameProj(proj)" class="btn btn-green btn-small">
                                            Save
                                        </button>
                                    </div>
                                    <div *ngIf="false" class="flex-row">
                                        <a>edit settings</a>
                                        <a>remove settings</a>
                                        <help-link helpId="38"></help-link>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td>
                            {{proj.lastModificationDate}}
                        </td>
                        <td>
                            <div class="flex-column">
                                {{proj.originalFilename}}
                                <div class="flex-column description">
                                    <div>
                                        Type: <span>Excel File</span>
                                    </div>
                                    <div *ngIf="false">
                                        Last read: <span>Aug 15 ‘20</span>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</main>